export default __webpack_public_path__ + "static/media/fectum-logo-white.5501bdf4.png";